
export function useSlideTitle() {
  const title = `Crop commodity price index by crop vs. gold/crude oil/DAX/S&P 500`;
  return title;
}